<nz-modal
  [(nzVisible)]="showAlertsModal"
  [nzTitle]="title"
  [nzFooter]="null"
  [nzWidth]="400"
  (nzOnCancel)="onModalCancel()"
>
  <ng-container *nzModalContent>
    <div class="alert-modal-content">
      <app-ticker-search
        *ngIf="alertType === alertTypeEnum.company"
        [isComp]="false"
        [showSelectedValue]="true"
        (tickerToEmit)="addSearchedTicker($event)"
      ></app-ticker-search>

      <app-watchlist-dropdown
        *ngIf="userId && alertType === alertTypeEnum.watchlist"
        [userId]="userId"
        (selectWatchlistFunc)="onWatchlistChange($event)"
      ></app-watchlist-dropdown>

      <div class="alert-type-container">
        <app-alerts-popover
          *ngIf="alertsParams; else emptyTemplate"
          [params]="alertsParams"
          (onSet)="onModalOk()"
          [okBtnText]="okBtnText"
          showCancelButton="true"
          (onCancel)="onModalCancel()"
        ></app-alerts-popover>

        <ng-template #emptyTemplate>
          <div class="empty-template-content">
            <ul class="alerts-list">
              <li>
                <div class="main-values">
                  <va-icon size="small" [isFontAwesome]="true" [name]="faBell" class="icon"></va-icon>
                  <span>Revision</span>
                </div>
              </li>
              <li>
                <div class="main-values">
                  <va-icon size="small" [isFontAwesome]="true" [name]="faBell" class="icon"></va-icon>
                  <span>Earnings</span>
                </div>
              </li>
              <li>
                <div class="main-values">
                  <va-icon size="small" [isFontAwesome]="true" [name]="faBell" class="icon"></va-icon>
                  <span>New Model</span>
                </div>
                <ul class="sub-values">
                  <li class="option-disabled">
                    <span>Brokers (0 of 0) &nbsp;</span>
                    <!-- <va-icon name="faAngleRight" class="icon"></va-icon> -->
                    <va-icon size="small" name="chevron-right" class="icon"></va-icon>
                  </li>
                </ul>
              </li>
              <li>
                <div class="main-values option-disabled">
                  <!-- <va-icon name="faAngleRight" class="icon"></va-icon> -->
                  <va-icon size="small" name="chevron-right" class="icon"></va-icon>
                  <span>Email Frequency</span>
                </div>
              </li>
            </ul>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</nz-modal>
